<template>
  <div>
    <div
      class="mb-4 col-sm-12 col-md-12 col-lg-12 col-xl-12"
      style="position: relative; padding: 0"
    >
      <b-row
        class="col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="
          align-items: center;
          justify-content: flex-end;
          position: absolute;
          top: -35px;
          right: 15px;
          padding: 0;
          width: 265px;
        "
      >
        <div style="display: flex; gap: 1rem">
          <label class="custom-checkbox" v-if="multipleReleases">
            <input v-model="fixedSalary" name="dummy" type="checkbox" />
            <span class="checkmark"></span>
            Vencimento fixo?
          </label>

          <label
            class="custom-checkbox"
            v-if="multipleReleases && typeItem.typeId === 'id'"
          >
            <input v-model="repeatReleases" name="dummy" type="checkbox" />
            <span class="checkmark"></span>
            Repetir lançamento?
          </label>

          <label
            class="custom-checkbox"
            v-if="
              !bill.id &&
              paymentCreditCardType(bill.idFormaPagamento) !==
                typePayments.cartaoDeCredito &&
              !paymentMoneyIsSelected
            "
          >
            <input
              v-model="multipleReleases"
              name="dummy"
              type="checkbox"
              @change="changeMultipleReleases"
            />
            <span class="checkmark"></span>
            Varios Lançamentos
          </label>
        </div>
      </b-row>

      <div class="contentBills mt-3" size="sm" style="gap: 2rem">
        <div style="flex: 1 1 200px; min-width: 250px">
          <InputSelect
            label="Forma de pagamento"
            valueField="id"
            textField="nome"
            :items="allPaymentsTypes"
            :dataSelect.sync="bill.idFormaPagamento"
            :openCreateModal="() => openModals('modalPaymentMethods')"
            ref="refFormaPagamento"
            @changed="selectPayment"
          />
        </div>

        <div style="flex: 1 1 200px; min-width: 250px">
          <InputSelect
            label="Conta de recebimento"
            valueField="id"
            textField="nome"
            :isDisabled="disabledInputs"
            :items="allAccountReceiptBills"
            :dataSelect.sync="bill.idContaRecebimento"
            :openCreateModal="() => openModals('modalFromGenerateBills')"
            ref="refContaDeRecebimento"
          />
        </div>

        <div style="max-width: 80px; min-width: 80px" v-if="multipleReleases">
          <Input
            label="Interval."
            :labelFixed="true"
            type="text"
            :dataInput.sync="intervaloDias"
            ref="refIntervaloDePagamento"
            :isDisabled="paymentMoneyIsSelected"
            key="intervaloDias"
          />
        </div>

        <div style="flex: 1 1 180px; min-width: 180px; max-width: 180px">
          <Input
            :label="bill.id ? 'Vencimento' : 'Venc. 1º parcela'"
            :labelFixed="true"
            type="date"
            :dataInput.sync="bill.data"
            ref="refVencimentoPrimeiraParcela"
            key="data"
          />
        </div>

        <div
          style="flex: 1 1 180px; min-width: 180px; max-width: 180px"
          v-if="getPaymentTypeMoneyId !== bill.idFormaPagamento && bill.id"
        >
          <Input
            label="Data Pagamento"
            :labelFixed="true"
            type="date"
            :dataInput.sync="bill.dataPagamento"
            ref="refDataPagamento"
            key="dataPagamento"
          />
        </div>

        <div
          style="max-width: 80px; min-width: 80px"
          v-if="!bill.id && multipleReleases"
        >
          <Input
            label="Parcelas"
            :labelFixed="true"
            type="text"
            :dataInput.sync="totalParcelas"
            ref="refTotalParcelas"
            :isDisabled="paymentMoneyIsSelected"
            key="totalParcelas"
          />
        </div>

        <div
          style="max-width: 130px; min-width: 130px"
          v-if="
            paymentCreditCardType(bill.idFormaPagamento) ===
            typePayments.cartaoDeCredito
          "
        >
          <div class="selectPlus">
            <label class="fixedSelect">Parcelamento</label>
            <b-form-select
              value-field="value"
              text-field="text"
              class="borderInput shadow-none"
              :options="amountInstallments"
              v-model="bill.parcelas"
              size="sm"
            >
            </b-form-select>
          </div>
        </div>

        <div style="flex: 1 1 100px; max-width: 100px">
          <InputMoney
            label="Valor Total"
            :labelFixed="true"
            type="text"
            :dataInput.sync="bill.valorTotal"
            ref="refValorTotalBill"
            isSelectAll
            key="valorTotal"
            @changed="handleCalcRemainingValue"
          />
        </div>

        <div
          style="flex: 1 1 100px; max-width: 100px"
          v-if="
            !multipleReleases && getPaymentTypeMoneyId !== bill.idFormaPagamento
          "
        >
          <InputMoney
            label="Valor Pago"
            :labelFixed="true"
            type="text"
            :dataInput.sync="bill.valorPago"
            ref="refValorPago"
            isSelectAll
            key="valorPago"
            @changed="handleCalcRemainingValue"
          />
        </div>

        <div
          style="flex: 1 1 100px; max-width: 100px"
          v-if="getPaymentTypeMoneyId !== bill.idFormaPagamento"
        >
          <InputMoney
            label="Valor Restante"
            :labelFixed="true"
            type="text"
            :dataInput.sync="bill.valorRestante"
            ref="refValorRestante"
            isSelectAll
            key="valorRestante"
            isDisabled
          />
        </div>

        <div style="flex: 1 1 150px; max-width: 150px">
          <Input
            label="Cód referência"
            type="text"
            :dataInput.sync="bill.codigoReferencia"
            :labelFixed="true"
            ref="codigoReferencia"
          />
        </div>

        <div v-if="isProvider" style="flex: 1 1 200px; max-width: 200px">
          <InputSelect
            label="Categoria"
            valueField="id"
            textField="nome"
            :items="allCategoryBills"
            :dataSelect.sync="bill.idCategoria"
            :openCreateModal="() => openModals('modalCategoriaConta')"
            ref="idCategoria"
          />
        </div>

        <div v-if="isProvider" style="flex: 1 1 80px; max-width: 80px">
          <Input
            label="Nº NF-e"
            type="text"
            :dataInput.sync="bill.numNfe"
            :labelFixed="true"
            ref="numNfe"
          />
        </div>

        <div style="flex: 1 1 30%; max-width: 30%">
          <Input
            label="Descrição"
            :labelFixed="true"
            type="text"
            :dataInput.sync="bill.descricao"
            ref="descricao"
            isSelectAll
            key="descricao"
          />
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
          "
        >
          <button
            class="btnBills btnGenerateBills"
            style="display: flex; justify-content: center; align-items: center"
            @click="handleGenerateBills"
            :disabled="loadingToAddBill"
          >
            <b-spinner
              v-if="loadingToAddBill"
              style="width: 20px; height: 20px; color: white"
            />

            <p style="margin: 0" v-else>Adicionar</p>
          </button>

          <button
            v-if="bill.id"
            class="btnBills btnCancelEditBills"
            @click="clearBill"
          >
            <b-icon-plus scale="2" class="icon" />
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="listBills.length"
      style="
        background-color: rgb(175 173 173 / 12%);
        padding: 10px;
        border-radius: 5px;
      "
    >
      <div class="titleBills">
        <p>Pagamentos</p>

        <div
          v-if="totalValue"
          style="
            border: solid 1px rgb(77 128 222);
            padding: 0.3rem;
            border-radius: 50px;
            background-color: rgb(220 226 238);
            color: rgb(0 86 255);
            font-size: 12px;
            line-height: 1;
          "
        >
          Pendente: {{ maskCurrency(calculatePendingValue()) }}
        </div>
      </div>

      <div class="summaryForm">
        <div class="summaryRes">
          <table>
            <thead>
              <tr>
                <th class="tdAndThFistValidity"></th>
                <th>
                  <p class="mr-2 titleItensBills">Vencimento</p>
                </th>
                <th>
                  <p class="mr-2 titleItensBills">Pagamento</p>
                </th>
                <th class="tdAndThValue">
                  <p class="mr-2 titleItensBills">Vl. Restante</p>
                </th>
                <th style="width: 20%">
                  <p class="mr-2 titleItensBills">Forma de Pagamento</p>
                </th>
                <th style="width: 15%" v-if="!typeCashier">
                  <p class="mr-2 titleItensBills">Conta</p>
                </th>
                <th style="width: 15%">
                  <p class="titleItensBills">Descrição</p>
                </th>
                <th style="width: 15%">
                  <p class="actionsTitle">Ações</p>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(bills, index) in listBills" :key="bills.id">
                <td class="tdAndThFistValidity">
                  {{ index + 1 }}/{{ listBills.length }}
                </td>
                <td class="tdAndThWithInputsDate">
                  <div style="display: flex; gap: 0.5rem; align-items: center">
                    <b-icon-clock
                      scale="1.2"
                      style="color: rgb(156 163 175 / 1)"
                    />

                    <p style="margin: 0; color: black">
                      {{
                        bills.data
                          ? bills.data.split("-").reverse().join("/")
                          : ""
                      }}
                    </p>
                  </div>
                </td>
                <td
                  class="tdAndThWithInputsDate2"
                  :style="`${
                    !bills.dataPagamento && 'color: #a1a1a1; font-style: italic'
                  }`"
                >
                  {{
                    bills.dataPagamento
                      ? bills.dataPagamento.split("-").reverse().join("/")
                      : "Não informado"
                  }}
                </td>
                <td class="tdAndThValue">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 2px 10px;
                      background-color: rgb(220 252 231 / 1);
                      border-radius: 50px;
                      box-shadow: rgb(22 101 52 / 21%) 0px 0px 0px 1px;
                    "
                  >
                    <p
                      style="
                        margin: 0;
                        color: rgb(22 101 52 / 1);
                        font-size: 0.75rem;
                      "
                    >
                      {{ maskCurrency(bills.valorTotal - bills.valorPago) }}
                    </p>
                  </div>
                </td>
                <td>
                  <div style="display: flex; gap: 0.5rem; align-items: center">
                    <p
                      style="
                        margin: 0;
                        font-size: 16px;
                        color: rgb(22 163 74 / 1);
                      "
                    >
                      $
                    </p>

                    <p style="margin: 0; color: black">
                      {{ getPaymentTypeName(bills.idFormaPagamento) }}
                      {{ bills.parcelas && `- ${bills.parcelas}X` }}
                    </p>
                  </div>
                </td>
                <td v-if="!typeCashier">
                  <div style="display: flex; gap: 0.5rem; align-items: center">
                    <b-icon-card-heading
                      scale="1.2"
                      style="color: rgb(0, 86, 255)"
                    />

                    <p style="margin: 0; color: black">
                      {{ getAccountReceiptName(bills.idContaRecebimento) }}
                    </p>
                  </div>
                </td>
                <td
                  class="tdAndThWithInputsOb"
                  :style="`${
                    !bills.descricao && 'color: #a1a1a1; font-style: italic'
                  }`"
                >
                  {{ bills.descricao || "Não informado" }}
                </td>
                <td
                  style="
                    width: 100%;
                    height: 30px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 0.3rem;
                  "
                >
                  <div
                    class="contentActionsBill"
                    @click="handleRemoveBill(bills)"
                    :style="
                      loadingToDelete &&
                      'pointer-events: none; background-color: rgb(233 233 233)'
                    "
                  >
                    <b-spinner
                      v-if="loadingToDelete && idToDelete === bills.id"
                      class="spin"
                    />

                    <b-icon-trash v-else style="color: brown" scale="1.5" />
                  </div>

                  <div
                    class="contentActionsBill"
                    @click="editBill(bills, index)"
                  >
                    <b-icon-pen style="color: rgb(88 128 255)" scale="1.5" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <ModalCreateAccountReceiptBill
      @getNewReceiptBill="getAllReceiptBill"
      modalId="modalFromGenerateBills"
    />

    <ModalPaymentMethods @listPaymentMethods="listPaymentMethods" />
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations } from "vuex";

import Input from "../UI/CustomInputs/Input.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import InputMoney from "../UI/CustomInputs/InputMoney.vue";
import ModalCreateAccountReceiptBill from "../Modals/ModalCreateAccountReceiptBill.vue";
import ModalPaymentMethods from "../Modals/ModalPaymentMethods.vue";

import ServiceBill from "../../services/serviceBill";

import { maskCurrency } from "../../utils/maskMoney";
import { removeReference } from "../../utils/removeReference";
import { INITIAL_STATE_SALE_BILL } from "../../initialStates/saleBill";
import { TypePayments } from "../../utils/enums/TypePayments";

import {
  ValidateBillsWhenGenerating,
  ValidateBillsWhitinSimpleSafe,
} from "../../validators/bills";
import { typesInstallment } from "../../common";

export default {
  props: {
    typeBill: {
      type: String,
      required: true,
      validator: (value) => ["entrada", "saida"].includes(value),
    },
    idCliente: {
      type: String,
      default: null,
    },
    idFornecedor: {
      type: String,
      default: null,
    },
    isProvider: {
      type: Boolean,
      default: false,
    },
    idFuncionario: {
      type: String,
    },
    typeItem: {
      type: Object,
      default: () => ({
        typeId: null,
        id: null,
      }),
    },
    totalValue: {
      type: [String, Number],
    },
    saleIsCanceled: {
      type: Boolean,
    },
    typeCashier: {
      type: [String, Number],
    },
    allAccountReceiptBills: {
      type: Array,
    },
    allPaymentsTypes: {
      type: Array,
    },
    allCategoryBills: {
      type: Array,
    },
    outsideBills: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Input,
    InputSelect,
    InputMoney,
    ModalCreateAccountReceiptBill,
    ModalPaymentMethods,
  },
  data() {
    return {
      enableConfirmButton: true,
      isRemovedBills: false,
      isChangedBill: {},
      maskCurrency: maskCurrency,
      loadingToDelete: false,
      idToDelete: null,
      bill: removeReference(INITIAL_STATE_SALE_BILL),
      fixedSalary: false,
      loadingToAddBill: false,
      paymentMoneyIsSelected: false,
      totalParcelas: 1,
      intervaloDias: 0,
      multipleReleases: false,
      paymentSelected: "",
      receiptBillSelected: "",
      amountInstallments: typesInstallment,
      listBills: [],
      repeatReleases: false,
      typePayments: TypePayments,
      idxItemEditing: null,
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_BILLS_FROM_SALE"]),
    async handleGenerateBills() {
      const isNotValid = this.validateBills();
      if (isNotValid) {
        return this.$toast.open({
          message: isNotValid,
          type: "info",
        });
      }

      this.handleGetTypePaymentAndReceiptBill();
      await this.makingThePayment();

      this.$emit("getBills", this.listBills);
    },
    async deleteBill(billId) {
      try {
        await ServiceBill.deleteAllRelationshipsFromDuplicate(billId);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao excluir essa conta!",
          type: "info",
        });
      }
    },
    async handleRemoveBill(outsideBill) {
      this.idToDelete = outsideBill.id;

      if (outsideBill.id) {
        try {
          this.loadingToDelete = true;
          await this.deleteBill(outsideBill.id);

          if (
            this.typeItem.typeId !== "idVenda" ||
            this.typeItem.typeId !== "idVendaMtq"
          ) {
            this.listBills = this.listBills.filter(
              (bill) => bill.id !== outsideBill.id
            );
          }
        } catch (error) {
          return this.$toast.open({
            message:
              error?.response?.data?.message ||
              "Ocorreu um problema ao remover este lançamento",
          });
        } finally {
          this.loadingToDelete = false;
          this.idToDelete = null;
        }
      }

      await this.handleFindBills();
    },
    async makingThePayment() {
      try {
        this.loadingToAddBill = true;
        if (!this.remainingValueIsValid()) {
          return this.$toast.open({
            message:
              "Não é possível informar o valor do lançamento (zerado) ou maior que o valor pendente!",
            type: "info",
          });
        }

        const payload = this.paymentMoneyIsSelected
          ? this.handleMoneyPaymentSelected()
          : this.repeatReleases
          ? this.handleRepeatReleases()
          : this.handleOthersPaymentSelected();

        if (this.bill.id) {
          this.bill.dataPagamento =
            this.bill.valorPago && !this.bill.dataPagamento
              ? moment().format("YYYY-MM-DD")
              : this.bill.dataPagamento;

          this.bill.tipo = this.typeBill;

          await ServiceBill.updateWithoutFiles(this.bill);

          if (
            this.typeItem.typeId === "idVenda" ||
            this.typeItem.typeId === "idVendaMtq"
          ) {
            await this.handleFindBills();
          } else {
            const newList = [...this.listBills];
            newList[this.idxItemEditing] = { ...this.bill };

            this.listBills = newList;
          }
        } else {
          const result = await ServiceBill.saveBySale({
            data: payload,
          });

          if (
            this.typeItem.typeId === "idVenda" ||
            this.typeItem.typeId === "idVendaMtq"
          ) {
            await this.handleFindBills();
          } else {
            if (result?.bills?.length)
              this.listBills = [...this.listBills, ...result.bills].sort(
                (a, b) => (moment(a.data).isAfter(b.data) ? 1 : -1)
              );
          }
        }

        this.clearBill();
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;

        this.$toast.open({
          message: message || "Ocorreu um problema ao lançar pagamentos",
          type: "info",
        });
      } finally {
        this.loadingToAddBill = false;
      }
    },
    async handleFindBills() {
      let result = [];

      if (this.typeItem.typeId === "idVenda")
        result = await ServiceBill.findByIdSale(this.typeItem.id);
      else if (this.typeItem.typeId === "idVendaMtq")
        result = await ServiceBill.findByIdSaleSquareMeter(this.typeItem.id);

      if (
        this.typeItem.typeId === "idVenda" ||
        this.typeItem.typeId === "idVendaMtq"
      ) {
        const newBillsFromSale =
          result?.map((item) => {
            return {
              ...item,
              data: item.data.split(" ")[0],
              dataPagamento: item.dataPagamento?.split(" ")[0],
              dataCompetencia: item.dataCompetencia?.split(" ")[0],
            };
          }) || [];

        this.listBills = newBillsFromSale;
      }

      this.$emit("getBills", this.listBills);
    },
    handleMoneyPaymentSelected() {
      const item = {
        id: this.bill.id,
        tipo: this.typeBill,
        idCliente: this.idCliente,
        idFornecedor: this.idFornecedor,
        idFuncionario: this.idFuncionario,
        idFormaPagamento: this.bill.idFormaPagamento,
        valorTotal: this.bill.valorTotal,
        valorPago: this.bill.valorTotal,
        valorRestante: this.bill.valorTotal,
        idUnion: this.bill.idUnion,
        data: this.bill.data,
        dataPagamento: this.bill.data,
        dataCompetencia: this.bill.data,
        descricao: this.bill.descricao,
        codigoReferencia: this.bill.codigoReferencia,
        numNfe: this.bill.numNfe,
        idCategoria: this.bill.idCategoria,
        idContaRecebimento: this.bill.idContaRecebimento,
        parcelas: null,
      };

      if (this.typeItem.typeId) item[this.typeItem.typeId] = this.typeItem.id;

      return [item];
    },
    handleRepeatReleases() {
      let baseDate = moment(this.bill.data);

      return Array.from({ length: this.totalParcelas }).map((_, i) => {
        let dataVencimento;

        if (this.fixedSalary) {
          dataVencimento = moment(this.bill.data)
            .add(i, "months")
            .format("YYYY-MM-DD");
        } else {
          dataVencimento =
            i === 0
              ? baseDate.format("YYYY-MM-DD")
              : baseDate.add(this.intervaloDias, "days").format("YYYY-MM-DD");
        }

        const item = {
          id: this.bill.id,
          tipo: this.typeBill,
          idCliente: this.idCliente,
          idFornecedor: this.idFornecedor,
          idFuncionario: this.idFuncionario,
          idFormaPagamento: this.bill.idFormaPagamento,
          idVenda: this.typeItem.typeId === "idVenda" ? this.id : null,
          idVendaMtq: this.typeItem.typeId === "idVendaMtq" ? this.id : null,
          valorTotal: this.bill.valorTotal,
          valorPago: this.bill.valorPago,
          valorRestante: this.bill.valorTotal,
          data: dataVencimento,
          parcelas:
            this.paymentCreditCardType(this.bill.idFormaPagamento) ===
            TypePayments.cartaoDeCredito
              ? this.bill.parcelas
              : null,
          dataCompetencia: moment().format("YYYY-MM-DD"),
          dataPagamento:
            this.bill.valorPago && !this.bill.dataPagamento
              ? moment().format("YYYY-MM-DD")
              : this.bill.dataPagamento,
          descricao: this.bill.descricao,
          codigoReferencia: this.bill.codigoReferencia,
          numNfe: this.bill.numNfe,
          idCategoria: this.bill.idCategoria,
          idContaRecebimento: this.bill.idContaRecebimento,
          idUnion: this.bill.idUnion,
        };

        if (this.typeItem.typeId) item[this.typeItem.typeId] = this.typeItem.id;

        return item;
      });
    },
    handleOthersPaymentSelected() {
      const { rest, baseValue } = this.handleCalcRestBills(
        this.bill.valorRestante,
        this.totalParcelas
      );

      let baseDate = moment(this.bill.data);
      return Array.from({ length: this.totalParcelas }).map((_, i) => {
        let dataVencimento;

        if (this.fixedSalary) {
          dataVencimento = moment(this.bill.data)
            .add(i, "months")
            .format("YYYY-MM-DD");
        } else {
          dataVencimento =
            i === 0
              ? baseDate.format("YYYY-MM-DD")
              : baseDate.add(this.intervaloDias, "days").format("YYYY-MM-DD");
        }

        const newValue =
          i === Number(this.totalParcelas) - 1 ? baseValue + rest : baseValue;

        const item = {
          id: this.bill.id,
          tipo: this.typeBill,
          idCliente: this.idCliente,
          idFornecedor: this.idFornecedor,
          idFuncionario: this.idFuncionario,
          idFormaPagamento: this.bill.idFormaPagamento,
          idVenda: this.typeItem.typeId === "idVenda" ? this.id : null,
          idVendaMtq: this.typeItem.typeId === "idVendaMtq" ? this.id : null,
          valorTotal: this.multipleReleases ? newValue : this.bill.valorTotal,
          valorPago: this.multipleReleases ? 0 : this.bill.valorPago,
          valorRestante: this.multipleReleases
            ? newValue
            : this.bill.valorTotal,
          data: dataVencimento,
          parcelas:
            this.paymentCreditCardType(this.bill.idFormaPagamento) ===
            TypePayments.cartaoDeCredito
              ? this.bill.parcelas
              : null,
          dataCompetencia: moment().format("YYYY-MM-DD"),
          dataPagamento:
            this.bill.valorPago && !this.bill.dataPagamento
              ? moment().format("YYYY-MM-DD")
              : this.bill.dataPagamento,
          descricao: this.bill.descricao,
          codigoReferencia: this.bill.codigoReferencia,
          numNfe: this.bill.numNfe,
          idCategoria: this.bill.idCategoria,
          idContaRecebimento: this.bill.idContaRecebimento,
          idUnion: this.bill.idUnion,
        };

        if (this.typeItem.typeId) item[this.typeItem.typeId] = this.typeItem.id;

        return item;
      });
    },
    changeMultipleReleases() {
      this.bill.valorPago = 0;

      this.handleCalcRemainingValue();

      if (!this.multipleReleases) {
        this.totalParcelas = 1;
        this.bill.parcelas = null;
      }
    },
    handleCalcRestBills(total = 0, length) {
      const baseValue = Math.floor((total / length) * 100) / 100;

      const totalSum = baseValue * length;
      const rest = Number((total - totalSum).toFixed(2));

      return {
        rest,
        baseValue,
      };
    },
    remainingValueIsValid() {
      const totalBills = this.listBills.reduce((prev, bill) => {
        if (bill.id !== this.bill.id) prev += bill.valorTotal;

        return Math.round(prev * 100) / 100;
      }, 0);

      const newTotalBills =
        Math.round((this.bill.valorTotal + totalBills) * 100) / 100;

      if (this.totalValue) {
        if (totalBills >= this.totalValue) {
          return false;
        } else if (newTotalBills > this.totalValue) {
          return false;
        }
      }

      return true;
    },
    handleCalcRemainingValue() {
      if (this.getPaymentTypeMoneyId === this.bill.idFormaPagamento) {
        this.bill.valorPago = this.bill.valorTotal;
        this.bill.valorRestante = 0.0;

        return;
      }

      if (!this.bill.valorPago) {
        this.bill.dataPagamento = null;
      }

      const remainingValue = this.bill.valorTotal - this.bill.valorPago;

      this.bill.valorRestante = remainingValue;

      if (this.$refs.refValorRestante) {
        this.$refs.refValorRestante.valueInput = remainingValue;
      }
    },
    selectPayment() {
      this.paymentMoneyIsSelected = false;
      const payment = this.allPaymentsTypes.find(
        (formPayment) => formPayment.id === this.bill.idFormaPagamento
      );

      if (this.typeCashier) {
        const accountPayment = this.allAccountReceiptBills.find(
          (account) => account.nome === "CAIXA GAVETA"
        );

        this.bill.idContaRecebimento = accountPayment.id;
        this.$refs.refContaDeRecebimento.valueItems = accountPayment.id;
      }

      if (payment.tipo === TypePayments.dinheiro) {
        this.multipleReleases = false;
        this.paymentMoneyIsSelected = true;

        const accountPayment = this.allAccountReceiptBills.find(
          (account) => account.nome === "CAIXA GAVETA"
        );

        this.bill.idContaRecebimento = accountPayment.id;
        this.$refs.refContaDeRecebimento.valueItems = accountPayment.id;
      } else if (payment.tipo === TypePayments.cartaoDeCredito) {
        this.showNumberOfInstallments = true;
        this.multipleReleases = false;
        this.repeatReleases = false;
        this.fixedSalary = false;
        this.totalParcelas = 1;
      }
    },
    validateBills() {
      if (this.typeCashier) {
        const dataFromGenerateBill = {
          tipo: this.typeBill,
          idCliente: this.idCliente,
          idFornecedor: this.idFornecedor,
          idFuncionario: this.idFuncionario,
          idFormaPagamento: this.bill.idFormaPagamento,
          idContaRecebimento: this.bill.idContaRecebimento,
          intervaloDias: this.intervaloDias,
          vencimento: this.bill.data,
          quantidadeParcelas: this.totalParcelas,
        };
        return ValidateBillsWhitinSimpleSafe(dataFromGenerateBill);
      } else {
        const dataFromGenerateBill = {
          tipo: this.typeBill,
          idCliente: this.idCliente,
          idFornecedor: this.idFornecedor,
          idFuncionario: this.idFuncionario,
          idFormaPagamento: this.bill.idFormaPagamento,
          idContaRecebimento: this.bill.idContaRecebimento,
          intervaloDias: this.intervaloDias,
          vencimento: this.bill.data,
          quantidadeParcelas: this.totalParcelas,
        };
        return ValidateBillsWhenGenerating(dataFromGenerateBill);
      }
    },
    handleGetTypePaymentAndReceiptBill() {
      if (this.bill.idFormaPagamento) {
        const typePayment = this.allPaymentsTypes.filter(
          (payment) => payment.id === this.bill.idFormaPagamento
        );

        const receiptBill = this.allAccountReceiptBills.filter(
          (receiptBills) => receiptBills.id === this.bill.idContaRecebimento
        );

        this.paymentSelected = typePayment[0].tipo;
        if (!this.typeCashier) {
          this.receiptBillSelected = receiptBill[0].nome;
        }
      }
    },
    clearBill() {
      this.bill = removeReference(INITIAL_STATE_SALE_BILL);
      this.paymentMoneyIsSelected = false;
      this.paymentSelected = "";
      this.receiptBillSelected = "";

      this.totalParcelas = 1;
      this.intervaloDias = 30;

      this.multipleReleases = false;
      this.fixedSalary = false;

      if (!this.typeCashier) {
        this.bill.idContaRecebimento = "";
      }

      this.$refs.refContaDeRecebimento.valueItems = "";
      this.$refs.refFormaPagamento.valueItems = "";

      if (this.$refs.refVencimentoPrimeiraParcela)
        this.$refs.refVencimentoPrimeiraParcela.valueInput = "";

      if (this.$refs.refValorTotalBill)
        this.$refs.refValorTotalBill.valueInput = "";

      if (this.$refs.refValorRestante)
        this.$refs.refValorRestante.valueInput = "";

      if (this.$refs.refValorPago) this.$refs.refValorPago.valueInput = "";

      if (this.$refs.descricao) this.$refs.descricao.valueInput = "";

      if (this.$refs.codigoReferencia)
        this.$refs.codigoReferencia.valueInput = "";

      if (this.$refs.numNfe) this.$refs.numNfe.valueInput = "";

      if (this.$refs.idCategoria) this.$refs.idCategoria.valueItems = "";
    },
    editBill(bill, idx) {
      this.idxItemEditing = idx;

      this.bill.tipo = bill.tipo;
      this.bill.idCliente = bill.idCliente;
      this.bill.idFornecedor = bill.idFornecedor;
      this.bill.idFuncionario = bill.idFuncionario;
      this.bill.idFormaPagamento = bill.idFormaPagamento;
      this.bill.idContaRecebimento = bill.idContaRecebimento;
      this.bill.idVenda =
        this.typeItem.typeId === "idVenda" ? bill.idVenda : null;
      this.bill.idVendaMtq =
        this.typeItem.typeId === "idVendaMtq" ? bill.idVendaMtq : null;
      this.bill.valorTotal = bill.valorTotal;
      this.bill.valorPago = bill.valorPago;
      this.bill.valorRestante = bill.valorRestante;
      this.bill.data = bill.data;
      this.bill.dataPagamento = bill.dataPagamento;
      this.bill.dataCompetencia = bill.dataCompetencia;
      this.bill.id = bill.id;
      this.bill.idUnion = bill.idUnion;
      this.bill.idCategoria = bill.idCategoria;
      this.bill.parcelas = bill.parcelas;
      this.bill.descricao = bill.descricao;
      this.bill.observacoes = bill.observacoes;
      this.bill.codigoReferencia = bill.codigoReferencia;
      this.bill.numNfe = bill.numNfe;
      this.bill.createdAt = bill.createdAt;

      this.$refs.refContaDeRecebimento.valueItems = bill.idContaRecebimento;
      this.$refs.refFormaPagamento.valueItems = bill.idFormaPagamento;

      if (this.$refs.descricao)
        this.$refs.descricao.valueInput = bill.descricao;

      if (this.$refs.refVencimentoPrimeiraParcela)
        this.$refs.refVencimentoPrimeiraParcela.valueInput = bill.data;

      if (this.$refs.refValorRestante)
        this.$refs.refValorRestante.valueInput = bill.valorRestante;

      if (this.$refs.refValorPago)
        this.$refs.refValorPago.valueInput = bill.valorPago;

      if (this.$refs.refValorTotalBill)
        this.$refs.refValorTotalBill.valueInput = bill.valorTotal;

      if (this.$refs.codigoReferencia)
        this.$refs.codigoReferencia.valueInput = bill.codigoReferencia;

      if (this.$refs.numNfe) this.$refs.numNfe.valueInput = bill.numNfe;

      if (this.$refs.idCategoria)
        this.$refs.idCategoria.valueItems = bill.idCategoria;

      this.paymentMoneyIsSelected = false;
      const typePayment = this.allPaymentsTypes.find(
        (formPayment) => formPayment.id === this.bill.idFormaPagamento
      );

      if (typePayment?.tipo === "Dinheiro") {
        this.paymentMoneyIsSelected = true;
      }
    },
    loadOutsideBills() {
      if (!this.outsideBills.length) return;

      this.listBills = this.outsideBills.map((bill) => ({
        ...bill,
        data: bill.data?.split(" ")[0],
        dataPagamento: bill.dataPagamento?.split(" ")[0],
        dataCompetencia: bill.dataCompetencia?.split(" ")[0],
      }));

      this.$emit("getBills", this.listBills);
      this.$nextTick(() => this.editBill(this.listBills[0], 0));
    },
    calculatePendingValue() {
      const peddingValueBill = this.listBills.reduce(
        (prev, bill) => (prev += bill.valorTotal),
        0
      );

      const result =
        Math.round((this.totalValue - peddingValueBill) * 100) / 100;

      const fixedResult = Math.abs(result) === 0 ? 0 : result;

      return fixedResult;
    },
    listPaymentMethods() {
      this.$emit("listPaymentMethods");
    },
    getBillsNotChanged() {
      const billsNotChanged = Object.keys(this.isChangedBill).filter(
        (changedBill) => {
          return this.isChangedBill[parseInt(changedBill)] === false;
        }
      );

      return billsNotChanged;
    },
    async getAllReceiptBill() {
      const accountPayment = this.allAccountReceiptBills.find(
        (account) => account.nome === "CAIXA GAVETA"
      );

      if (this.typeCashier) {
        this.bill.idContaRecebimento = accountPayment.id;
        this.$refs.refContaDeRecebimento.valueItems = accountPayment.id;
      }

      this.$emit("newAccountReceiptBillCreated", this.allAccountReceiptBills);
    },
    handleIsPaid(idx, idFormaPagamento) {
      if (idFormaPagamento !== this.getPaymentTypeMoneyId) {
        this.$refs.isPaidBill[idx].disabled = false;
      } else {
        this.$refs.isPaidBill[idx].disabled = true;
        this.$refs.isPaidBill[idx].checked = true;
      }
    },
    getPaymentTypeName(id) {
      return this.allPaymentsTypes.find((payment) => payment.id === id)?.nome;
    },
    getAccountReceiptName(id) {
      return this.allAccountReceiptBills.find((account) => account.id === id)
        ?.nome;
    },
    openModals(idModal) {
      this.$bvModal.show(idModal);
    },
    paymentCreditCardType(id) {
      return this.allPaymentsTypes.find((payment) => payment.id === id)?.tipo;
    },
  },
  computed: {
    ...mapState({
      dataConfig: (state) => state.dataConfig,
    }),
    getPaymentTypeMoneyId() {
      return this.allPaymentsTypes.find((payment) => payment.cod === "01")?.id;
    },
    typePaymentSelected() {
      return this.bill.idFormaPagamento;
    },
    disabledInputs() {
      if (this.paymentMoneyIsSelected) return true;
      else if (this.typeCashier) return true;

      return false;
    },
    outsideId() {
      return this.typeItem.id;
    },
  },
  watch: {
    typePaymentSelected() {
      if (this.typePaymentSelected) {
        const payment = this.allPaymentsTypes.find(
          (payment) => payment.id === this.typePaymentSelected
        );

        if (payment.tipo === "Dinheiro") {
          this.paymentMoneyIsSelected = true;
          this.intervaloDias = 0;
          this.bill.data = moment().format("YYYY-MM-DD");
          this.totalParcelas = 1;

          if (this.$refs.refIntervaloDePagamento)
            this.$refs.refIntervaloDePagamento.valueInput = this.intervaloDias;

          if (this.$refs.refVencimentoPrimeiraParcela)
            this.$refs.refVencimentoPrimeiraParcela.valueInput = this.bill.data;

          if (this.$refs.refTotalParcelas)
            this.$refs.refTotalParcelas.valueInput = this.totalParcelas;
        } else {
          this.paymentMoneyIsSelected = false;
        }
      }
    },
    outsideId() {
      this.handleFindBills();
    },
  },
  mounted() {
    this.getAllReceiptBill();
    this.loadOutsideBills();
  },
};
</script>

<style scoped>
.summaryForm {
  display: flex;
  flex-direction: column;
  color: #00486e;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.summaryForm label {
  margin-bottom: 0px;
}

.footerBtn {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 1rem;
}

#modalParcelas {
  color: #00486e;
  font-size: 17px;
}

table {
  border-collapse: separate;
  border-spacing: 0 8px;
}

th {
  text-align: center !important;
  font-weight: normal;
}

.tdAndThWithInputs {
  width: 20%;
}

.tdAndThWithInputsOb {
  width: 15%;
  font-weight: 600;
}

.tdAndThWithInputsDate {
  width: 15%;
}

.tdAndThWithInputsDate2 {
  width: 12%;
  color: black;
}

.tdAndThPercentageInputs {
  width: 10%;
}

.tdAndThFistValidity {
  width: 4%;
  color: #afadad;
  font-size: 14px;

  margin-bottom: 0px;
}

.spin {
  width: 20px;
  height: 20px;
  color: #7e7e7e;
}

.tdAndThValue {
  width: 13%;
  padding: 0 1.5rem;
}

.btnBills {
  height: 28px;
  border-radius: 5px;
  background-color: transparent;
  width: 115px;
  border: none;
  border: solid 1px black;
  color: black;
  font-size: 12px;
}

.btnRemove {
  background-color: transparent;
  border: solid 1px red;
  color: red;
}

.summaryTitle h5 {
  color: #00486e;
}

.titleItensBills {
  color: #666360;
  font-size: 12px;

  margin-bottom: 0px;
  text-align: start;
}

.actionsTitle {
  color: #666360;
  font-size: 12px;
  margin-bottom: 0px;
}

.user-label {
  position: absolute;
  left: 5px;
  font-size: 12px;
  color: #00395d;
  bottom: 6px;
  color: #777777;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
}

.input {
  font-size: 12px !important;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.2em;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.borderInput {
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
  font-size: 12px;
}

.borderInput:focus {
  border: 1px solid #a9cff4;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 10px 1rem;
}

.repeatlaunch {
  margin: 0px;
  color: #666360;
  white-space: nowrap;
}

.titleBills {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: solid 1px #cdcdcd;
  padding: 0.2rem 0;
}

.titleBills p {
  font-size: 12px !important;

  color: #666360 !important;
  margin: 5px 0px;
}

.contentActionsBill {
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  transition: ease-in all 0.1s;
  border: solid 1px #c0c0c0;
  background-color: white;
}

.contentActionsBill:hover {
  background-color: #ededed;
}

/* The slider */
.switch {
  font-size: 14px;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: -12px;
  left: 10px;
  bottom: 0;
  background-color: #d9d9d9;
  color: black;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 55px !important;
  height: 27px;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "";
  font-size: 13px;
  height: 23px;
  width: 25.6px !important;
  left: 2px;
  border-radius: 50px;
  background-color: white;
  color: black;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: black;
}

.switch input:checked + .slider:before {
  content: "";
  background-color: white;
  transform: translateX(100%);
  color: black;
}

.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  color: #333;
  transition: color 0.3s;
  margin: 0;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 14px;
  height: 14px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 12px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #000000;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #f0f0f0;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}

.contentBills {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  bottom: 20px;
  left: 12px;
  z-index: 2;
  background-color: #ffff;
  font-size: 11px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  padding: 0 0.2em;
}

.custom-select:disabled {
  color: black;
  background-color: #d5d3d3;
}

.custom-select {
  background: none;
  text-transform: capitalize;
}

.btnBills {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  height: 30px;
  border: none;
  color: white;
  font-size: 12px;
}

.btnGenerateBills {
  width: 80px;
  background-color: #0fbf4d;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.325);
  color: white;
}

.btnCancelEditBills {
  width: 30px;
  background-color: brown;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.325);
  color: white;
}

.btnCancelEditBills .icon {
  transform: rotate(45deg);
}

.summaryRes table {
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .summaryForm {
    overflow: auto;
    padding: 0 0.3rem;
    height: 200px;
  }

  *::-webkit-scrollbar {
    width: 5px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #00486e;
    border-radius: 2px;
  }

  .summaryRes {
    padding: 0 0.2rem;
    min-width: 1100px;
  }

  .containerBills {
    padding: 10px 0 0 10px;
  }
}
</style>
